(function () {
  if (window.__IG_ID12_FASLET_STYLE__) return;
  window.__IG_ID12_FASLET_STYLE__ = true;

  var CLASS_NAME = "ig-id12-a";

  var BUTTON_STYLES = {
    width: "fit-content",
    "min-width": "0",
    "max-width": "100%",
    height: "26px",
    "min-height": "26px",
    "max-height": "26px",
    "border-radius": "6.12px",
    "box-sizing": "border-box",
    "white-space": "nowrap"
  };

  var PARENT_STYLES = {
    width: "fit-content",
    "max-width": "100%",
    height: "auto",
    "min-height": "0",
    margin: "0",
    padding: "0"
  };

  function isVariant() {
    return document.documentElement.classList.contains(CLASS_NAME);
  }

  function applyImportant(el, styles) {
    if (!el || !el.style) return;
    Object.keys(styles).forEach(function (key) {
      el.style.setProperty(key, styles[key], "important");
    });
  }

  function queryDeep(selector, root) {
    var results = [];
    var scope = root || document;

    function walk(node) {
      if (!node) return;
      if (node.querySelectorAll) {
        Array.prototype.forEach.call(node.querySelectorAll(selector), function (el) {
          results.push(el);
        });
        Array.prototype.forEach.call(node.querySelectorAll("*"), function (el) {
          if (el.shadowRoot) walk(el.shadowRoot);
        });
      }
      if (node.shadowRoot) walk(node.shadowRoot);
    }

    walk(scope);
    return results;
  }

  function hideHosts() {
    var hosts = document.querySelectorAll(
      "faslet-app, #faslet-button, .faslet-container, [id*='faslet'], .shopify-block[id*='faslet']"
    );
    Array.prototype.forEach.call(hosts, function (el) {
      applyImportant(el, { display: "none" });
    });
  }

  function clearHostHide() {
    var hosts = document.querySelectorAll(
      "faslet-app, #faslet-button, .faslet-container, [id*='faslet'], .shopify-block[id*='faslet']"
    );
    Array.prototype.forEach.call(hosts, function (el) {
      if (el.style && el.style.getPropertyValue("display") === "none") {
        el.style.removeProperty("display");
      }
    });
  }

  function applyLocale() {
    var locale =
      window.__FASLET_LOCALE__ ||
      (document.documentElement && document.documentElement.lang) ||
      "";
    if (!locale) return;

    var short = String(locale).toLowerCase().split("-")[0];
    var hosts = document.querySelectorAll("faslet-app");
    Array.prototype.forEach.call(hosts, function (el) {
      if (el.getAttribute("locale") === short) return;
      el.setAttribute("locale", short);
    });
  }

  function styleButtons() {
    applyLocale();

    if (!isVariant()) {
      hideHosts();
      return;
    }

    clearHostHide();
    applyLocale();

    var buttons = queryDeep(".faslet-button");
    buttons.forEach(function (btn) {
      applyImportant(btn, BUTTON_STYLES);
      var parent = btn.parentElement;
      if (parent) applyImportant(parent, PARENT_STYLES);
    });
  }

  var scheduled = null;
  function schedule() {
    if (scheduled) return;
    scheduled = requestAnimationFrame(function () {
      scheduled = null;
      styleButtons();
    });
  }

  function boot() {
    schedule();
    setInterval(schedule, 500);
    var obs = new MutationObserver(schedule);
    obs.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style"]
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
